import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalAddAddressPageRoutingModule } from './modal-add-address-routing.module';

import { ModalAddAddressPage } from './modal-add-address.page';
//Components
import { ComponentsModule } from 'src/app/components/components.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    ModalAddAddressPageRoutingModule
  ],
  declarations: [ModalAddAddressPage]
})
export class ModalAddAddressPageModule {}
